import { atom } from 'recoil';

/**
 * VoIP付加サービス変更画面の入力 state。
 * API の数値的な契約状態とは別に、画面側で扱いやすい boolean とサービスパック値へ変換して保持する。
 */
export type VoipOptionChangeStateType = {
  optionNumberNotice: boolean; // 発信者番号通知 APIの値:0:通知する、1:通知しない
  optionNumberDisplay: boolean; // 番号表示 APIの値:0:申込無、1:申込有
  optionNumberRequest: boolean; // 番号リクエスト APIの値:0:申込無、1:申込有
  optionCatchPhone: boolean; // キャッチ電話 APIの値:0:申込無、1:申込有
  optionVoiceWarp: boolean; // 着信転送 APIの値:0:申込無、1:申込有
  optionStopNuisanceCall: boolean; // 着信お断り APIの値:0:申込無、1:申込有
  optionServicePack: string; // サービスパック(00:なし, 01:パック1, 02:パック2, 03:パック3, 04:パック4, 05:ベーシックパック)
};

/** VoIP付加サービス変更内容を保持する state。 */
export const VoipOptionChangeState = atom<VoipOptionChangeStateType>({
  key: 'VoipOptionChangeState',
  default: {
    optionNumberNotice: false,
    optionNumberDisplay: false,
    optionNumberRequest: false,
    optionCatchPhone: false,
    optionVoiceWarp: false,
    optionStopNuisanceCall: false,
    optionServicePack: '', // APIの値で初期化するため、初期化済みか判断できるように空文字をセット
  },
});

export default VoipOptionChangeState;
